<!-- Saúde -->
<div class="row match-height" *ngIf="!isOdonto(); else ehOdonto">
  <div class="col-lg-12 col-xl-12">
    <div id="accordionWrapa1" role="tablist" aria-multiselectable="true">
      <div class="col-lg-12 col-xl-12">
        <!-- Angariação -->
        <div
          id="heading1"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          role="tab"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#angariacao"
            aria-expanded="false"
            aria-controls="angariacao"
            class="card-title lead collapsed"
            >Angariação
          </a>
        </div>
        <div
          id="angariacao"
          role="tabpanel"
          aria-labelledby="heading1"
          class="collapse"
        >
          <div class="card-content">
            <div class="card-body">
              A taxa de angariação deve ser paga ao corretor pelo próprio
              beneficiário no ato da assinatura da proposta, por conta da
              intermediação da contratação do benefício, cujo valor é diverso
              (diferente) do valor mensal do benefício contratado. A taxa de
              angariação NÃO se confunde, isenta, exclui ou substitui o
              pagamento da primeira mensalidade. Em caso de não aceitação da
              proposta, essa taxa deverá ser integralmente devolvida ao
              beneficiário pelo corretor.
            </div>
          </div>
        </div>
        <!-- Área de Comercialização -->
        <div
          id="heading2"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#area"
            aria-expanded="false"
            aria-controls="area"
            class="card-title lead collapsed"
            >Área de Comercialização</a
          >
        </div>
        <div
          id="area"
          role="tabpanel"
          aria-labelledby="heading2"
          class="collapse"
          aria-expanded="false"
        >
          <div class="card-content">
            <div class="card-body">
              Este produto pode ser comercializado no estado de São Paulo.
            </div>
          </div>
        </div>
        <!-- Área de Utilização -->
        <div
          id="comer"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#accordion3"
            aria-expanded="false"
            aria-controls="accordion3"
            class="card-title lead collapsed"
          >
            Área de Utilização
          </a>
        </div>
        <div
          id="accordion3"
          role="tabpanel"
          aria-labelledby="comer"
          class="collapse"
          aria-expanded="false"
        >
          <div class="card-content">
            <div class="card-body">
              <p>
                A área de utilização do produto será de acordo com a tabela
                contratada:
              </p>
              <p>
                <b>Estadual</b> - estado de São Paulo <b>Nacional</b> - a nível
                nacional nas Unimeds locais.
              </p>
            </div>
          </div>
        </div>
        <!-- Cancelamento do Contrato -->
        <div
          id="heading4"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#cancelamento"
            aria-expanded="false"
            aria-controls="cancelamento"
            class="card-title lead collapsed"
            >Cancelamento do Contrato</a
          >
        </div>
        <div
          id="cancelamento"
          role="tabpanel"
          aria-labelledby="heading4"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  O atraso de prazo superior a 30 dias no pagamento da
                  mensalidade do plano coletivo por adesão acarreta o
                  cancelamento do contrato e as mensalidades em aberto
                  constituem dívida.
                  <p>
                    A exclusão do beneficiário titular, por quaisquer dos
                    motivos previstos na proposta, acarretará automaticamente a
                    exclusão dos beneficiários dependentes. Em casos de migração
                    ou desistência, é necessário enviar carta de próprio punho,
                    assinada pelo titular do plano, para o cancelamento do
                    contrato, desde que não existam boletos em aberto. Poderá
                    ocorrer à cobrança em Juízo dos valores das respectivas
                    faturas não paga pelo titular. Caso ocorra a perda da
                    elegibilidade na Entidade o contrato poderá ser cancelado.
                    As solicitações deverão ser encaminhadas para Central de
                    Atendimento 3660-2000.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Carências -->
        <div
          id="heading5"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#carenciass"
            aria-expanded="false"
            aria-controls="carenciass"
            class="card-title lead collapsed"
            >Carências
          </a>
        </div>
        <div
          id="carenciass"
          role="tabpanel"
          aria-labelledby="heading5"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  As carências contratuais contadas a partir do início de
                  vigência do benefício.
                </li>
                <li>
                  Mínimo de 12 meses de permanência no plano anterior
                  ininterrupto.
                </li>
                <li>
                  Sem interrupção de pagamento do plano anterior e no máximo até
                  60 dias de suspensão de pagamento do plano anterior ao início
                  dos benefícios;
                </li>
                <li>Todas as propostas passarão por análise.</li>
                <li>
                  Não há redução de carências para planos com cobertura somente
                  hospitalar.
                </li>
                <li>
                  Não há redução para plano com abrangência não compatível.
                </li>
                <li>
                  Somente haverá redução de carência para plano com acomodação
                  igual ou inferior a contratação atual.
                </li>
                <li>
                  *A redução de carência não se aplica a parto a termo e CPT.
                </li>
                <li>
                  <b>Operadoras Congêneres: </b>AGF / Omint / NotreDame
                  Intermédica / Unibanco / Golden Cross / Generalli /
                  Mediservice / Bradesco / Marítima / Amil / SulAmérica / Porto
                  Seguro / Medial / Gama / HSB
                  <span
                    >*Será analisada a similaridade entre produtos. Não há
                    compra de carências de produtos do sistema Unimed.
                  </span>
                </li>
                <li>
                  <b>Ex-beneficiários de planos individuais:</b> cópia do
                  contrato ou cartão de identificação, constando data de início
                  e cópia dos 03 últimos boletos quitados.
                </li>
                <li>
                  <b>Ex-beneficiários de planos empresariais ou adesão:</b>
                  declaração da Instituição em papel timbrado, atestando: data
                  de início, tempo de permanência, categoria, acomodação,
                  relação dos dependentes e data do último pagamento.
                </li>
                <li></li>
              </ul>
              <br />
              <hr />
              <p>
                <b>24 Horas </b> Urgências e Emergências – Acidentes Pessoais
                (conforme resolução CONSU nº13/88)
              </p>
              <p><b>30 Dias</b> Consultas e Exames Complementares</p>
              <p>
                <b>90 Dias</b> Fisioterapias, Exames Especiais e Procedimentos
                ambulatoriais.
              </p>
              <p>
                <b>180 Dias</b>Internações Clínicas e Cirúrgicas, Quimioterapia,
                Radioterapia, Diálise e Hemodiálise
              </p>
              <p><b>300 Dias</b>Parto a Termo</p>
              <span>
                CPT - Cobertura Parcial Temporária é a suspensão, por um período
                ininterrupto de até 24 meses, da cobertura de Procedimentos de
                Alta Complexidade (PAC), leitos de Alta tecnologia e
                procedimentos cirúrgicos, desde que relacionados exclusivamente
                às Doenças ou Lesões Preexistentes (DLP) declaradas pelo
                Beneficiário ou seu representante legal, através da Declaração
                Pessoal de Saúde (DPS).
              </span>
            </div>
          </div>
        </div>
        <!-- Composição / Quem Pode Aderir -->
        <div
          id="quemHeader"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#quem"
            aria-expanded="false"
            aria-controls="carenciass"
            class="card-title lead collapsed"
            >Composição / Quem Pode Aderir
          </a>
        </div>
        <div
          id="quem"
          role="tabpanel"
          aria-labelledby="quemHeader"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  <b>Elegibilidade</b> - Serão aceitos como titulares os
                  beneficiários com vínculo à entidade.
                </li>
                <li>
                  <b>Titular</b> - Funcionários públicos municipais, estaduais e
                  federais ativos ou inativos filiados a ADSERVIP.
                </li>
                <li>
                  <b>Dependentes</b> diretos: cônjuge ou companheiro(a)
                  homoafetivo, filhos naturais, adotivos ou enteados solteiros
                  até 30 anos 11 meses e 29 vidas e/ou filhos inválidos sem
                  limite de idade.
                </li>
                <li></li>
                <b>Dependentes indiretos:</b>
                irmãos, sobrinhos e netos até 30 anos 11 meses e 29 dias
              </ul>
            </div>
          </div>
        </div>
        <!-- Contratos e/ou Aditivos Vigentes -->
        <div
          id="heading5"
          class="card-header acordion-quest-w acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#accordion5"
            aria-expanded="false"
            aria-controls="accordion5"
            class="card-title lead collapsed"
            >Contratos e/ou Aditivos Vigentes
          </a>
        </div>
        <div
          id="accordion5"
          role="tabpanel"
          aria-labelledby="heading5"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>Proposta de adesão</li>
                <li>
                  Formulario para Analise de Carências -<a
                    href="https://storage.googleapis.com/trindade-arquivos-painel-v1-mr-us-prod/manuais/105416-geia-formcarencias.pdf"
                    target="_blank"
                  >
                    Clique aqui</a
                  >
                </li>
                <li>Carta de orientação ao beneficiário</li>
                <li>Ficha de associação</li>
                <li>
                  Termo Aditivo - Resolução Normativa 412 -
                  <a
                    href="https://storage.googleapis.com/trindade-arquivos-painel-v1-mr-us-prod/manuais/118688-termo-aditivo-rn-412.pdf"
                    target="_blank"
                  >
                    Clique aqui</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Diferenciais de Coberturas -->
        <div
          id="DiferenciaisId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#Diferenciais"
            aria-expanded="false"
            aria-controls="Diferenciais"
            class="card-title lead collapsed"
            >Diferenciais de Coberturas</a
          >
        </div>
        <div
          id="Diferenciais"
          role="tabpanel"
          aria-labelledby="DiferenciaisId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  <b>Remissão</b> 05 anos sem custo para os dependentes legais
                  em caso de falecimento do titular.
                </li>
                <li>
                  <strong
                    >Transporte Aeromédico Inter-hospitalar (UNIAIR):</strong
                  >
                  remoção aeromédica inter-hospitalar em caráter emergencial,
                  sob prescrição médica, solicitada por médico cooperado e
                  autorizada previamente pela Unimed. A central de Atendimento
                  da UNIAIR funciona de forma ininterrupta, 24 horas por dia, 7
                  dias por semana.
                </li>
                <li>
                  <strong>Orientação em saúde por telefone 24 horas: </strong
                  >Serviço disponível 24 horas por dia. Todo atendimento é
                  realizado de acordo com a legislação brasileira.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Documentos Necessários -->
        <div
          id="docsId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#docs"
            aria-expanded="false"
            aria-controls="docs"
            class="card-title lead collapsed"
            >Documentos Necessários</a
          >
        </div>
        <div
          id="docs"
          role="tabpanel"
          aria-labelledby="docsId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  <strong>Titular</strong> - cópia do RG, CPF, CNS-Cartão
                  Nacional de Saúde, comprovante de endereço atualizado (últimos
                  30 dias) e comprovante de vínculo à entidade.
                </li>

                <li>
                  <strong>Comprovante de vínculo (titular) -</strong> Holerite
                  atualizado, constando o desconto da ADSERVIP ou o holerite
                  atualizado juntamente com a ficha de associação preenchida e
                  assinada.
                </li>

                <li>
                  <strong>Cônjuge:</strong> cópia da certidão de casamento, RG,
                  CPF e CNS-Cartão Nacional da Saúde.
                </li>
                <li>
                  <strong>Companheiro(a):</strong> cópia do RG e CPF, CNS-Cartão
                  Nacional da Saúde, declaração de união estável lavrada em
                  cartório por tabelião, contendo o número do RG e do CPF,
                  endereço, tempo de convívio, firma reconhecida do titular e
                  do(a) companheiro(a), ou cópia da certidão de nascimento de
                  filhos em comum.
                </li>

                <li>
                  <strong>
                    Filhos naturais, adotivos ou enteados solteiros:</strong
                  >
                  cópia do RG, CPF, CNS-Cartão Nacional de Saúde, Certidão de
                  Nascimento (obrigatório para os nascidos a partir de 01/2010)
                  e/ ou termo de guarda.
                </li>
                <li>
                  <strong>Filhos inválidos de qualquer idade:</strong> cópia do
                  RG, CPF (para maiores de 18 anos), CNS-Cartão Nacional da
                  Saúde, certidão de nascimento e certidão de Invalidez emitida
                  pelo INSS.
                </li>
                <li>
                  <strong> Enteados solteiros - </strong> cópia RG, CPF,
                  CNS-Cartão Nacional de Saúde, certidão de nascimento e
                  declaração de dependência econômica do enteado autenticada em
                  cartório contendo RG e assinatura de 02 testemunhas. Titular
                  casado - acrescentar cópia da certidão de casamento.
                </li>

                <li>
                  <strong> Titular com companheiro - </strong> acrescentar
                  declaração de União estável de próprio punho, contendo o
                  número do RG e CPF, endereço tempo de convívio com firma
                  reconhecida do titular e do companheiro. Irmãos: cópia do RG,
                  CPF, CNS-Cartão Nacional da Saúde e certidão de nascimento.
                </li>
                <li>
                  <strong>Sobrinhos(as):</strong> cópia do RG, CPF, CNS-Cartão
                  Nacional da Saúde e RG do irmão(ã) do titular. Netos(as):
                  cópias do RG, CPF, CNS-Cartão Nacional da Saúde e certidão de
                  nascimento.
                </li>
                <li>
                  <strong>ATENÇÃO:</strong> O estipulante poderá requisitar a
                  qualquer momento outros documentos aqui não especificados, a
                  fim de comprovar as informações prestadas na proposta de
                  adesão
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Forma de Pagamento -->
        <div
          id="formaPagamentoId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#forPagamento"
            aria-expanded="false"
            aria-controls="forPagamento"
            class="card-title lead collapsed"
          >
            Forma de Pagamento</a
          >
        </div>
        <div
          id="forPagamento"
          role="tabpanel"
          aria-labelledby="formaPagamentoId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  <strong> Débito automático:</strong> Enviar cópia cheque,
                  cartão ou extrato bancário. OBS: Para realizarmos o débito em
                  sua conta, o banco requer que o cliente comande a autorização
                  de débito em sua conta corrente.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Movimentação Cadastral -->
        <div
          id="movimentacaoId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#movimentacao"
            aria-expanded="false"
            aria-controls="movimentacao"
            class="card-title lead collapsed"
          >
            Movimentação Cadastral</a
          >
        </div>
        <div
          id="movimentacao"
          role="tabpanel"
          aria-labelledby="movimentacaoId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  As solicitações de alterações cadastrais deverão ser feitas
                  por escrito ao Grupo Geia, apresentadas com a documentação
                  completa por meio dos canais de atendimento próprios, com
                  antecedência mínima de 15 dias, considerando-se sempre o dia
                  correspondente ao início de vigência do benefício. Toda
                  movimentação de inclusões, exclusões, cancelamento do
                  contrato, deve ser tratada diretamente na Administradora.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Prazo de Entrega das Propostas -->
        <div
          id="prazoId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#prazo"
            aria-expanded="false"
            aria-controls="prazo"
            class="card-title lead collapsed"
            >Prazo de Entrega das Propostas</a
          >
        </div>
        <div
          id="prazo"
          role="tabpanel"
          aria-labelledby="prazoId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  Após a data e assinatura da proposta o prazo máximo de entrega
                  da mesma é de 48 horas de segunda a sexta-feira.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Reajuste das Mensalidades -->
        <div
          id="reajusteMensalidadeId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#reajusteMensalidadeHref"
            aria-expanded="false"
            aria-controls="reajuste"
            class="card-title lead collapsed"
            >Reajuste das Mensalidades</a
          >
        </div>
        <div
          id="reajusteMensalidadeHref"
          role="tabpanel"
          aria-labelledby="reajusteMensalidadeId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  Independente da data de adesão do beneficiário ao contrato, o
                  valor mensal do benefício poderá sofrer reajustes legais e
                  contratuais, de forma cumulativa (parcial ou total) ou
                  isolada, nas seguintes situações:
                  <p>1. Reajuste financeiro; e</p>
                  <p>2. Por índice de sinistralidade.</p>
                  <p>No mês subsequente ao aniversário do beneficiário:</p>
                  <p>1. Por mudança de faixa etária.</p>

                  <p>
                    O contrato coletivo firmado entre a Administradora e a
                    Operadora vigorará pelo reajustes mínimo de 12 meses,
                    podendo ser renovado, automaticamente, por reajustes
                    indeterminado, desde que não ocorra denúncia, por escrito,
                    de qualquer das partes, seja pela Administradora ou pela
                    Operadora.
                  </p>

                  <p>
                    Em caso de rescisão desse contrato coletivo, a Geia fará a
                    comunicação desse fato, com antecedência mínima de 30 dias.
                  </p>
                </li>
                <li>Mês de reajuste anual - Junho</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Regras Gerais -->
        <div
          id="regrasGeralId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#regrasGeralHref"
            aria-expanded="false"
            aria-controls="reajuste"
            class="card-title lead collapsed"
          >
            Regras Gerais
          </a>
        </div>
        <div
          id="regrasGeralHref"
          role="tabpanel"
          aria-labelledby="regrasGeralId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  <strong>Titular: </strong>a assinatura do contrato de adesão
                  deve ser exatamente igual ao documento entregue (RG ou CNH), é
                  obrigatório informar também o número do telefone e e-mail do
                  titular.
                </li>
                <li>
                  Atendendo à Instrução Normativa da Receita Federal, todas as
                  propostas deverão ser acompanhadas da cópia de documento com o
                  número do CPF de todos os beneficiários (titulares ou
                  dependentes) com idade igual ou superior a 8 anos.
                </li>
                <li>
                  Para segurados com idade igual ou superior a 59 anos, entrar
                  em contato com a nossa área técnica.
                </li>
                <li>
                  Rasuras ou preenchimento incorreto - na data da vigência, e
                  nome da Entidade não são aceitas, necessário refazer a
                  proposta.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Telefones Úteis -->
        <div
          id="telefoneId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#telefonesHref"
            aria-expanded="false"
            aria-controls="telefone"
            class="card-title lead collapsed"
          >
            Telefones Úteis
          </a>
        </div>
        <div
          id="telefonesHref"
          role="tabpanel"
          aria-labelledby="telefoneId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>Central de atendimento: 3660 2000</li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Vigência / Vencimento -->
        <div
          id="vigenciaVencimentoId"
          class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
        >
          <a
            data-toggle="collapse"
            data-parent="#accordionWrapa1"
            href="#vigenciaVencimento"
            aria-expanded="false"
            aria-controls="vigenciaVencimento"
            class="card-title lead collapsed"
          >
            Vigência / Vencimento
          </a>
        </div>
        <div
          id="vigenciaVencimento"
          role="tabpanel"
          aria-labelledby="vigenciaVencimentoId"
          class="collapse"
          aria-expanded="false"
          style="height: 0px"
        >
          <div class="card-content">
            <div class="card-body">
              <ul>
                <li>
                  Entrega de propostas até as 12:00 hs no dia do fechamento
                </li>
                <li>
                  O primeiro valor mensal do benefício é pago no início da
                  vigência.
                </li>
                <li>
                  Os valores mensais serão pagos através de boleto bancário ou
                  débito automático em conta corrente do titular nos seguintes
                  bancos: Banco do Brasil 001, Itaú 341, Caixa Econômica Federal
                  104 e Santander 033.
                </li>
              </ul>
              <table class="table mt-1">
                <thead>
                  <th>Data de adesão</th>
                  <th>Inicio de vigência</th>
                  <th>Vencimento</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Até dia 14 de cada mês</td>
                    <td>Dia 1º do mês seguinte</td>
                    <td>5º dia útil do mês da vigência</td>
                  </tr>
                  <tr>
                    <td>De 15 a 25 de cada mês</td>
                    <td>Dia 15 do mês seguinte</td>
                    <td>5º dia útil do mês da vigência</td>
                  </tr>
                  <tr>
                    <td>De 26 a 31 de cada mês</td>
                    <td>Dia 1° do segundo mês seguinte</td>
                    <td>5º dia útil do mês da vigência</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #ehOdonto>
  <!-- Odonto-->
  <div class="row match-height">
    <div class="col-lg-12 col-xl-12">
      <div id="accordionWrapa1" role="tablist" aria-multiselectable="true">
        <div class="col-lg-12 col-xl-12">
          <!-- Angariação -->
          <div
            id="heading1"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
            role="tab"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#angariacao"
              aria-expanded="false"
              aria-controls="angariacao"
              class="card-title lead collapsed"
              >Angariação
            </a>
          </div>
          <div
            id="angariacao"
            role="tabpanel"
            aria-labelledby="heading1"
            class="collapse"
          >
            <div class="card-content">
              <div class="card-body">
                A taxa de angariação deve ser paga ao corretor pelo próprio
                beneficiário no ato da assinatura da proposta, por conta da
                intermediação da contratação do benefício, cujo valor é diverso
                (diferente) do valor mensal do benefício contratado. A taxa de
                angariação NÃO se confunde, isenta, exclui ou substitui o
                pagamento da primeira mensalidade. Em caso de não aceitação da
                proposta, essa taxa deverá ser integralmente devolvida ao
                beneficiário pelo corretor.
              </div>
            </div>
          </div>
          <!-- Cancelamento do Contrato -->
          <div
            id="heading4"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#cancelamento"
              aria-expanded="false"
              aria-controls="cancelamento"
              class="card-title lead collapsed"
              >Cancelamento do Contrato</a
            >
          </div>
          <div
            id="cancelamento"
            role="tabpanel"
            aria-labelledby="heading4"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    O atraso de prazo superior a 30 dias no pagamento da
                    mensalidade do plano coletivo por adesão acarreta o
                    cancelamento do contrato e as mensalidades em aberto
                    constituem dívida.
                    <p>
                      A exclusão do beneficiário titular, por quaisquer dos
                      motivos previstos na proposta, acarretará automaticamente
                      a exclusão dos beneficiários dependentes. Em casos de
                      migração ou desistência, é necessário enviar carta de
                      próprio punho, assinada pelo titular do plano, para o
                      cancelamento do contrato, desde que não existam boletos em
                      aberto. Poderá ocorrer à cobrança em Juízo dos valores das
                      respectivas faturas não paga pelo titular. Caso ocorra a
                      perda da elegibilidade na Entidade o contrato poderá ser
                      cancelado. As solicitações deverão ser encaminhadas para
                      Central de Atendimento 3660-2000.
                    </p>
                  </li>
                  <li>
                    <p>
                      Se atentar à possibilidade de estorno de comissão e/ou
                      premiação. Verificar junto à operadora se há necessidade
                      de permanência mínima no contrato, sob pena de multa, caso
                      o cancelamento seja feito antes do prazo.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Carências -->
          <div
            id="heading5"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#carenciass"
              aria-expanded="false"
              aria-controls="carenciass"
              class="card-title lead collapsed"
              >Carências
            </a>
          </div>
          <div
            id="carenciass"
            role="tabpanel"
            aria-labelledby="heading5"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    <p><b>24 Horas </b> Urgências e Emergências</p>
                    <p><b>60 Dias</b> Demais Procedimentos</p>
                  </li>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Composição / Quem Pode Aderir -->
          <div
            id="quemHeader"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#quem"
              aria-expanded="false"
              aria-controls="carenciass"
              class="card-title lead collapsed"
              >Composição / Quem Pode Aderir
            </a>
          </div>
          <div
            id="quem"
            role="tabpanel"
            aria-labelledby="quemHeader"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    <b>Elegibilidade</b> - Serão aceitos como titulares os
                    beneficiários com vínculo à entidade.
                  </li>
                  <li>
                    <b>Dependentes indiretos:</b>
                    pai, mãe, netos, sobrinhos, sogro e sogra sem limite de
                    idade.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Documentos Necessários -->
          <div
            id="docsId"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#docs"
              aria-expanded="false"
              aria-controls="docs"
              class="card-title lead collapsed"
              >Documentos Necessários</a
            >
          </div>
          <div
            id="docs"
            role="tabpanel"
            aria-labelledby="docsId"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    <strong>Titular</strong> - cópia do RG e CPF ou CNH,
                    CNS-Cartão Nacional de Saúde, comprovante de endereço atual.
                  </li>
                  <li>
                    <strong>Cônjuge:</strong> cópia da certidão de casamento,
                    RG, CPF e CNS-Cartão Nacional da Saúde.
                  </li>
                  <li>
                    <strong> Irmãos(ãs):</strong>
                    Cópia do RG ou CNH, ou certidão de nascimento para
                    comprovação de vínculo com o titular.
                  </li>
                  <li>
                    <strong> Sobrinhos(as): </strong> cópia RG ou CNH dos
                    sobrinhos e certidão de casamento dos pais ou cópia da
                    certidão de nascimento dos sobrinhos para comprovação de
                    vínculo.
                  </li>
                  <li>
                    <strong> Pai/Mãe: </strong> cópia do RG, CPF e CNS-Cartão
                    Nacional da Saúde.
                  </li>
                  <li>
                    <strong>Sogro(a):</strong> cópia do RG, CPF, CNS-Cartão
                    Nacional da Saúde e RG do cônjuge do títular.
                  </li>
                  <li>
                    <strong>ATENÇÃO:</strong> O estipulante poderá requisitar a
                    qualquer momento outros documentos aqui não especificados, a
                    fim de comprovar as informações prestadas na proposta de
                    adesão
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Reajuste das Mensalidades -->
          <div
            id="reajusteMensalidadeId"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#reajusteMensalidadeHref"
              aria-expanded="false"
              aria-controls="reajuste"
              class="card-title lead collapsed"
              >Reajuste das Mensalidades</a
            >
          </div>
          <div
            id="reajusteMensalidadeHref"
            role="tabpanel"
            aria-labelledby="reajusteMensalidadeId"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    Independente da data de adesão do beneficiário ao contrato,
                    o valor mensal do benefício poderá sofrer reajustes legais e
                    contratuais, de forma cumulativa (parcial ou total) ou
                    isolada, nas seguintes situações:
                    <p>1. Reajuste financeiro; e</p>
                    <p>2. Por índice de sinistralidade.</p>
                    <p>No mês subsequente ao aniversário do beneficiário:</p>
                    <p>1. Por mudança de faixa etária.</p>

                    <p>
                      O contrato coletivo firmado entre a Administradora e a
                      Operadora vigorará pelo reajustes mínimo de 12 meses,
                      podendo ser renovado, automaticamente, por reajustes
                      indeterminado, desde que não ocorra denúncia, por escrito,
                      de qualquer das partes, seja pela Administradora ou pela
                      Operadora.
                    </p>

                    <p>
                      Em caso de rescisão desse contrato coletivo, a Geia fará a
                      comunicação desse fato, com antecedência mínima de 30
                      dias.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Regras Gerais -->
          <div
            id="regrasGeralId"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#regrasGeralHref"
              aria-expanded="false"
              aria-controls="reajuste"
              class="card-title lead collapsed"
            >
              Regras Gerais
            </a>
          </div>
          <div
            id="regrasGeralHref"
            role="tabpanel"
            aria-labelledby="regrasGeralId"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    <strong>Titular: </strong>a assinatura do contrato de adesão
                    deve ser exatamente igual ao documento entregue (RG ou CNH),
                    é obrigatório informar também o número do telefone e e-mail
                    do titular.
                  </li>
                  <li>
                    Atendendo à Instrução Normativa da Receita Federal, todas as
                    propostas deverão ser acompanhadas da cópia de documento com
                    o número do CPF de todos os beneficiários (titulares ou
                    dependentes) com idade igual ou superior a 8 anos.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Telefones Úteis -->
          <div
            id="telefoneId"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#telefonesHref"
              aria-expanded="false"
              aria-controls="telefone"
              class="card-title lead collapsed"
            >
              Telefones Úteis
            </a>
          </div>
          <div
            id="telefonesHref"
            role="tabpanel"
            aria-labelledby="telefoneId"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>Central de atendimento: 3660 2000</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Vigência / Vencimento -->
          <div
            id="vigenciaVencimentoId"
            class="card-header acordion-quest-w collapse-format border-info mt-1 mb-1"
          >
            <a
              data-toggle="collapse"
              data-parent="#accordionWrapa1"
              href="#vigenciaVencimento"
              aria-expanded="false"
              aria-controls="vigenciaVencimento"
              class="card-title lead collapsed"
            >
              Vigência / Vencimento
            </a>
          </div>
          <div
            id="vigenciaVencimento"
            role="tabpanel"
            aria-labelledby="vigenciaVencimentoId"
            class="collapse"
            aria-expanded="false"
            style="height: 0px"
          >
            <div class="card-content">
              <div class="card-body">
                <ul>
                  <li>
                    O primeiro valor mensal do benefício é pago no início da
                    vigência.
                  </li>
                  <li>
                    Os valores mensais serão pagos através de boleto bancário ou
                    débito automático em conta corrente do titular nos seguintes
                    bancos: Banco do Brasil 001, Itaú 341, Caixa Econômica
                    Federal 104 e Santander 033.
                  </li>
                </ul>
                <table class="table mt-1">
                  <thead>
                    <th>Data de adesão</th>
                    <th>Data de vigência</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Até dia 15 de cada mês</td>
                      <td>Dia 1° do mês seguinte</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
